
export const AboutItem = ({title, desc, symbol, shortname, img}) => {
    let arr='';
    if(Array.isArray(title)){
        title.map(item=>{
            arr += item.name //+ ', '
            return true;
        })
        arr += ' knows'
    }
    return (
        <div className="edit__card"> 
                {shortname ? <div className="who shortname">{shortname}</div> : null}
                {img && <div className="who"><img src={img} alt="" /></div>}
                {!img && !shortname ? <div className="who">{symbol}</div> : null}

                <div className="">
                    {title && <div className="size-15">{Array.isArray(title) ? arr : title }</div>}
                    <p className="desc">{desc}</p>
                </div>
        </div>


    )
}
